import React from "react";
import UniversalForm from "../../../components/UniversalForm/UniversalForm";
import { useLeadFormConfig, LeadFormProps } from "../../../components/UniversalForm/entityForms";

const LeadForm: React.FC<LeadFormProps> = (props) => {
  const config = useLeadFormConfig(props);
  return (
    <>
      <style>{`
        .lead-form-responsive {
          max-width: 615px;
          margin: 0 auto;
        }

        @media (min-width: 1024px) {
          .lead-form-responsive {
            max-width: 922px;
          }
        }
      `}</style>
      <div className="lead-form-responsive">
        <UniversalForm key={config.resetKey} config={config} />
      </div>
    </>
  );
};

export default LeadForm;
